module.exports = __webpack_public_path__ + "img/instagram-icn.2970ca27.png";